import { render, staticRenderFns } from "./CustomerTableWithoutLabel.vue?vue&type=template&id=bb342706&"
import script from "./CustomerTableWithoutLabel.vue?vue&type=script&lang=js&"
export * from "./CustomerTableWithoutLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports